// servicesData.ts
import React from 'react';
import { BiCodeAltLogo } from '../assets/BiCodeAltLogo';
import { SparklesLogo } from '../assets/SparklesLogo';
import { RocketTakeoffLogo } from '../assets/RocketTakeoffLogo';

export interface Service {
    title: string;
    description: string;
    icon: React.ReactNode;
}

export const servicesData: Service[] = [
    {
        title: 'AI Integration',
        description:
            'AI integration and architecture. Multi-agent setup, RAG systems, monitoring, testing, production-ready.',
        icon: <SparklesLogo />,
    },
    {
        title: 'Full-Stack Dev',
        description:
            'Web and mobile applications. Focus on product and user experience first. Web stack. From 0 to 1.',
        icon: <BiCodeAltLogo />,
    },
    {
        title: 'Technical Leadership',
        description:
            'Part-time CTO for early-stage startups. Architecture, tech stack decisions, team building. Co-founded before.',
        icon: <RocketTakeoffLogo />,
    },
];
